import { render, staticRenderFns } from "./undo-redo-toolbox.vue?vue&type=template&id=138566b5&"
import script from "./undo-redo-toolbox.vue?vue&type=script&lang=ts&"
export * from "./undo-redo-toolbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports